import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Loader } from '../../../../../components/Loader';
import { VehicleCreateFieldCompany } from '../../../pages/create/FieldCompany';
import { VehicleCreateFieldCompanyUser } from '../../../pages/create/FieldCompanyUser';
import { initiateNewOrderValue, setNewOrderValue } from '../../../actions';
import { fetchUser } from '../../../../Users/actions';
import { initiateNewInvoiceValue, setNewInvoiceValue } from '../../../../Invoices/actions';
import { selectNewInvoice, selectNewInvoiceValue } from '../../../../Invoices/selectors';
import { selectNewOrder, selectNewOrderValue } from '../../../selectors';
import { selectWork } from '../../../../Api/selectors';
import { REQUEST_VEHICLE_PROPERTY_UPDATE } from '../../../constants';
import { REQUEST_USER } from '../../../../Users/constants';
import { AppClientId } from '../../../../Shared/constants';
import env from '../../../../../env';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import styles from './Fields.module.css';
import ButtonComponent from '../../../../../containers/App/Components/Button/Button';
import { Button } from '../../../../../components/Buttons';

dayjs.extend(customParseFormat);
const Container = styled.div`
  margin-bottom: 8px;
  width: 100%;
  .formField {
    .label {
      text-transform: capitalize;
      margin-bottom: 6px;
      color: #6c757d;
    }
  }

  .rightDecorationBlock {
    width: 100px;
    display: flex;

    .deleteBtn {
      background-color: #d50046;
    }
  }
`;

const RequireMark = styled.span`
  margin-left: 4 px;
  font-size: 24px;
  color: red;
`;

const STATE = {
  value: '',
  email_manual: '',
};

/* eslint-disable react/prefer-stateless-function */
class VehicleCreateOrderFieldComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {
    this.props.initiateValue();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.defaultFinancialContact != this.props.defaultFinancialContact) {
      this.props.setValue(this.props.defaultFinancialContact, 'financial_contact');
      this.props.setValue(this.props.defaultFinancialContact, 'client');
    }
  }

  addNewCompany() {
    this.props.showNewCompanyModal();
  }

  get isMobile() {
    return window.innerWidth <= 768;
  }

  wrap(children) {
    switch (this.props.type) {
      default:
        return (
          <div>
            <label className="form-label">{this.formFieldLabel()}</label>
            {children}
          </div>
        );
    }
  }

  formFieldLabel() {
    if (this.props.type == 'send_to_email') return this.lbl(`vehicle.order.send-to-mail`);
    return this.lbl(`vehicle.order.property.${this.props.type}`);
  }

  reset() {
    this.setState({ ...STATE });
  }

  render() {
    if (this.props.work) return <Loader small />;
    return <Container>{this.wrap(this.renderField())}</Container>;
  }

  renderField() {
    if (this.props.value === undefined) return null;

    switch (this.props.type) {
      case 'outgoingCompanyId':
        return (
          <div className={this.isMobile && !this.props.values?.outgoingCompanyId && styles.hBox}>
            <VehicleCreateFieldCompany
              size="xl"
              order={true}
              customerNumberSearch
              invoicePage={this.props.invoicePage}
              title={this.props.type}
              key={this.props.type}
              type={this.props.type}
              onChange={value => this.props.setValue(value)}
            />
            <div className={!this.isMobile && styles.buttonNew}>
              {!this.props.values.outgoingCompanyId && (
                <Button style={'ButtonSoftPrimary'} disabled={this.props.disabled} onClick={this.addNewCompany.bind(this)}>
                  {this.isMobile ? '+' : this.lbl('new_customer')}
                </Button>
              )}
            </div>
          </div>
        );
      case 'client':
        return (
          <>
            <div className={styles.wrapper}>
              <VehicleCreateFieldCompanyUser
                order
                invoicePage={this.props.invoicePage}
                title={this.props.type}
                companyId={this.props.values.outgoingCompanyId}
                key={`${this.props.type}-${this.props.values.outgoingCompanyId}`}
                type={this.props.type}
                onChange={value => {
                  this.props.setValue(value);
                  if (!this.props.values?.financial_contact) {
                    this.props.setValue(value, 'financial_contact');
                  }
                }}
              />

              {!this.props.values?.client && env.clientId === AppClientId.INDEWAL && <RequireMark>*</RequireMark>}
            </div>
          </>
        );
      case 'financial_contact':
        return (
          <VehicleCreateFieldCompanyUser
            financialContact={true}
            includeFinancialContact={this.props.values?.includeFinancialContact}
            order
            invoicePage={this.props.invoicePage}
            title={this.props.type}
            companyId={this.props.values.outgoingCompanyId}
            key={`${this.props.type}-${this.props.values.outgoingCompanyId}`}
            type={this.props.type}
            onChange={value => this.props.setValue(value)}
          />
        );

      case 'send_to_email':
        return (
          <div>
            <input
              placeholder="Enter email"
              className="form-control"
              disabled={this.props.values?.includeManual !== '1'}
              type="email"
              value={this.props.value}
              onChange={evt => {
                this.props.setValue(evt.target.value);
              }}
            />
          </div>
        );
    }
  }
}

VehicleCreateOrderFieldComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWork(REQUEST_VEHICLE_PROPERTY_UPDATE),
    userWork: selectWork(REQUEST_USER),
    value: ownProps.invoicePage ? selectNewInvoiceValue(ownProps.type) : selectNewOrderValue(ownProps.type),
    values: ownProps.invoicePage ? selectNewInvoice() : selectNewOrder(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    setValue(value, name = null) {
      name = name ?? ownProps.type;
      ownProps.invoicePage ? dispatch(setNewInvoiceValue(name, value)) : dispatch(setNewOrderValue(name, value));
    },
    initiateValue() {
      ownProps.invoicePage
        ? dispatch(initiateNewInvoiceValue(ownProps.type))
        : dispatch(initiateNewOrderValue(ownProps.type));
    },
    fetchUser(id, callback) {
      dispatch(fetchUser(id, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const VehicleCreateOrderField = compose(withConnect, withRouter)(VehicleCreateOrderFieldComp);
